import ForecastHour from './ForecastHour';
import {  Link } from "react-router-dom";
import { useState, useContext, useRef, useEffect, useLayoutEffect } from "react";
import { ResponsiveLine } from '@nivo/line';
import { useTranslation } from 'react-i18next';
const Forecast24h = (props) => {
    
    const { t } = useTranslation();
    const [mode, setMode] = useState('tempcloth');
    const containerRef = useRef(null);
    const [size, setSize] = useState({ width: 0, height: 0 });
    const isTemp = mode.indexOf('temp') > -1;
    const isHumidity = mode.indexOf('humidity') > -1;
    const isCloth = mode.indexOf('cloth') > -1;
    const isRainrate = mode.indexOf('rain') > -1;
    const temps = props.hours.map(h => h.temp);
    const minTemp = Math.min(...temps);
    const maxTemp = Math.max(...temps);
    useLayoutEffect(() => {
        if (!containerRef.current) return;

        const rect = containerRef.current.getBoundingClientRect();
        setSize({ width: rect.width, height: rect.height });
    }, [props.hours]);
    useEffect(() => {
        const rect = containerRef.current.getBoundingClientRect();
        setSize({ width: rect.width, height: rect.height });
    }, [props.hours]);

    const normalizeTemp = (temp) => {
     if (maxTemp === minTemp) return 50; // avoid divide by zero

        const percent = (temp - minTemp) / (maxTemp - minTemp);

        const MIN_HEIGHT = 12; // 👈 tweak (10–20 works well)
        const MAX_HEIGHT = 60;

        return MIN_HEIGHT + percent * (MAX_HEIGHT - MIN_HEIGHT);
    };

    const data = [
    {
        id: "temp",
        data: props.hours
        .slice()        // don't mutate original
        .reverse()      // 🔥 RTL fix
        .map((h, i) => ({
        x: `${h.time}:00`,
        y: h.temp
        }))
    }
    ];
        
       const temperatureOptions = {
            width: 1950,
            height: 280,
            margin: {
            top: 60, right: 10, bottom: 50, left: 10
            },
            xScale: {
            type: 'point',
            },
            yScale: {
            type: 'linear',
            min: 'auto',
            max: 'auto',
            stacked: false,
            reverse: false,
            },
            color: '#ff6b6b',
            curve:"monotoneX",
            enableGridX:'false'
            
           
        };

    
    return (
        <div id="graph_container">
            <h3>{t("FORECAST_TITLE")} - {t("HOURLY")}</h3>
            <div id="controls">
                    <ul id="controls_ul">
                            <li>
                                <Link className= {"" + (isTemp ? "underlined-link" : '') } onClick={() => setMode('temp')} >{t("TEMP")}</Link>
                            </li>
                            <li>
                                <Link className= {"" + (isHumidity ? "underlined-link" : '') } onClick={() => setMode('humidity')} >{t("HUMIDITY")}</Link>
                            </li>
                            <li>
                                <Link className= {"" + (isCloth ? "underlined-link" : '') } onClick={() => setMode('cloth')} >{t("CLOTH")}</Link>
                            </li>
                            <li>
                                <Link className= {"" + (isRainrate ? "underlined-link" : '') } onClick={() => setMode('rain')} >{t("CHANCE_OF") }{t("RAIN")}</Link>
                            </li>
                    </ul>
            </div>     			
            <div id="graph_forcast"  ref={containerRef} className={"metric-chart h-bar-chart white_box white_transp_box " + (props.lang == 1? 'rtl ' : '') + (props.vertical === true ? "vertical": "") }>
            
            <ul id="forcast_hours" className={"for24_graph_ng x-axis-bar-list count-10 " + (props.lang == 1? 'rtl ' : '') + (props.vertical === true ? "vertical": "") }>
            {props.hours.map((hour, i) => {
                return <ForecastHour key={i} {...hour} tempPercent={normalizeTemp(hour.temp)} sigHours={props.sigHours} cssClasses={props.cssClasses} lang={props.lang} isTemp={isTemp} isHumidity={isHumidity} isCloth={isCloth} isWind={false} isRainrate={isRainrate} vertical={props.vertical} isText={false} ></ForecastHour>;
            })}
            </ul>
            
                
            
            </div>

        </div>

        
    );
}

export default Forecast24h; 